import React from "react";
import "../../styles/components/facultyProfile/workloadSection.scss";
import { Button, Table, Typography, Tag, Space, Popover } from "antd";
import { PlusCircleOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";

export default function WorkloadSection({
  title,
  columns,
  data,
  selectedTerms,
  portfolioProps,
  onAdd,
  onEdit,
  children,
  includedInFsr = true,
  collapsed,
  onToggleCollapse,
}) {
  const visibleCount = 2;
  const visibleTerms = selectedTerms.slice(0, visibleCount);
  const hiddenTerms = selectedTerms.slice(visibleCount);

  const filteredData = (data) =>
    selectedTerms.length === 0
      ? data
      : data.filter((item) => selectedTerms.includes(item.academic_term));

  return (
    <div className="workload-section">
      <div className="header">
        <div className="header-row">
          <div
            className="collapse-toggle"
            style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
            onClick={onToggleCollapse}
          >
            <Typography.Title
              level={3}
              style={{
                margin: 0,
                color: "#862633",
              }}
            >
              {title}
            </Typography.Title>
            {includedInFsr && <Tag color="green">Included in FSR</Tag>}
          </div>

          <Space>
            <Button
              size="large"
              style={{ background: "#00573F" }}
              icon={<PlusCircleOutlined />}
              type="primary"
              onClick={onAdd}
            >
              Add
            </Button>
            <Button
              shape="circle"
              icon={collapsed ? <DownOutlined /> : <UpOutlined />}
              style={{ border: "1px solid #862633", color: "#862633" }}
              onClick={onToggleCollapse}
            />
          </Space>
        </div>

        <div>
          <span className="filter-label">Academic Terms: </span>

          {selectedTerms.length === 0 ? (
            "All"
          ) : (
            <Space size={4} wrap>
              {visibleTerms.map((term) => (
                <Tag
                  key={term}
                  color="blue"
                  style={{ fontSize: 14, fontWeight: 600, padding: "4px 10px" }}
                >
                  {term}
                </Tag>
              ))}

              {hiddenTerms.length > 0 && (
                <Popover
                  trigger="hover"
                  placement="topLeft"
                  content={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                      }}
                    >
                      {hiddenTerms.map((term) => (
                        <Tag key={term} color="blue">{term}</Tag>
                      ))}
                    </div>
                  }
                >
                  <Tag
                    color="blue"
                    style={{ cursor: "pointer", fontSize: 14, fontWeight: 600, padding: "4px 10px" }}
                  >
                    +{hiddenTerms.length}
                  </Tag>
                </Popover>
              )}
            </Space>
          )}
        </div>
      </div>

      {!collapsed && (
        children ? (
          children
        ) : (
          <Table
            columns={columns}
            dataSource={filteredData(data)}
            scroll={{ x: "max-content" }}
            pagination={{ pageSize: 4 }}
            onRow={(record) => ({
              onClick: () => {
                if (onEdit) onEdit(record);
              },
              style: { cursor: "pointer" },
            })}
            rowKey={(record) => record.id}
          />
        )
      )}
    </div>
  );
}
